import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { CommercialStructureEditService } from '../../service/commercial-structure-edit/commercial-structure-edit.service';

@Component({
	selector: 'app-commercial-structure-edit',
	templateUrl: './commercial-structure-edit.component.html',
	providers: [
		CommercialStructureEditService,
		HttpModule
	]

})
export class CommercialStructureEditComponent implements OnInit {

	private token;
	guid: string;
	private sub: any;
	commercialStructure: FormGroup;
	public structureDetails: any[] = [];
	public structureDetailsManagers: any[] = [];
	public commercialManagers: any[] = [];
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private route: ActivatedRoute, private commercialStructureEditService: CommercialStructureEditService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid'];
		});

		this.commercialStructureEditService.listCommercialStructureManagers(this.token, this.guid).subscribe(result => {
			this.structureDetailsManagers = result.Result.map((res: Response) => res);
			this.structureDetails = result.Result[0] ? result.Result[0].Superior : [];
			if (result.Success == true) {
				this.commercialStructureEditService.listManagers(this.token).subscribe(result => {
					this.commercialManagers = result.Result;

					for (var i = this.commercialManagers.length - 1; i >= 0; i--) {

						for (var j = this.structureDetailsManagers.length - 1; j >= 0; j--) {

							if (this.commercialManagers[i].CodigoSap == this.structureDetailsManagers[j].CodigoSap) {
								this.commercialManagers[i].checked = true;
							}
						}
					}
				});
			}

		}, error => {
			console.log(error);
			
		});
	}

	editCommercialStructure(nome, ativo) {

		var data = {
			CodigoSap: this.guid,
			Nome: nome,
			Ativo: ativo,
			Gerentes: []
		};

		var ListManagers = this.commercialManagers.filter(opt => opt.checked).map(opt => opt.CodigoSap);
		for (let obj of ListManagers) {
			console.log(obj);
			data.Gerentes.push({ CodigoSap: obj.toString(), Ativo: true })
		}

		this.commercialStructureEditService.editCommercialStructure(this.token, data).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Diretoria editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/estrutura-comercial');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/estrutura-comercial');
	}

}




// WEBPACK FOOTER //
// ./src/app/commercial-structure/component/commercial-structure-edit/commercial-structure-edit.component.ts